<template>
  <div class="page flex flex-col mh100">
    <el-form>
      <el-form-item>
        <toolbar :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
      </el-form-item>
    </el-form>
    <div class="flex-1 overA">
      <el-table :data="menuList" highlight-current-row v-loading="tableLoading" @current-change="selectCurrentRow"
        row-key="id" border lazy :load="load" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        style="width: 100%;">
        <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
        <el-table-column label="菜单/按钮" width="200">
          <template slot-scope="scope">
            <i class="fa" :class="scope.row.icon"></i>
            {{ scope.row.displayName }}
          </template>
        </el-table-column>
        <el-table-column prop="url" label="路由地址" width></el-table-column>
        <el-table-column prop="api" label="API接口" width></el-table-column>
        <el-table-column prop="order" label="Sort" width="100"></el-table-column>
        <el-table-column prop="type" label="是否按钮" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.type ? 'success' : 'danger'" disable-transitions>{{ scope.row.type ? "是" : "否" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="isVisible" label="是否显示" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isVisible ? 'success' : 'danger'" disable-transitions>{{ scope.row.isVisible ?
                "是" : "否"
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="isKeepAlive" label="keepAlive" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isKeepAlive ? 'success' : 'danger'" disable-transitions>{{ scope.row.isKeepAlive
                ? "是" : "否"
            }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          style="float: right"
          :total="total"
          :current-page="pageIndex"
          :pageSize="pageSize"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        ></el-pagination> -->
    </div>

    <el-dialog :title="isEdit ? '编辑' : '新增'" :visible.sync="menuFormVisible" v-if="menuFormVisible"
      v-model="menuFormVisible" :close-on-click-modal="false">
      <el-form :model="menuForm" label-width="120px" :rules="menuFormRules" ref="menuForm">
        <el-form-item label="名称" prop="name">
          <el-input v-model="menuForm.name" auto-complete="off" placeholder="请输入菜单英文名"></el-input>
        </el-form-item>
        <el-form-item label="菜单名称" prop="displayName">
          <el-input v-model="menuForm.displayName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="路由地址" prop="url">
          <el-tooltip class="item" effect="dark" content="如果是导航条且无路由，请填‘-’字符，如果是按钮，请输入空格即可" placement="top-start">
            <el-input v-model="menuForm.url" auto-complete="off"></el-input>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="描述" prop="customExtension">
          <el-input v-model="menuForm.target" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="icon" prop="icon">
          <el-input v-model="menuForm.icon" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="isActive">
          <el-select v-model="menuForm.isActive" placeholder="请选择状态">
            <el-option label="激活" :value="true"></el-option>
            <el-option label="禁用" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="order">
          <el-input v-model="menuForm.order" style="width:80"></el-input>
        </el-form-item>
        <el-form-item prop="type" label="是否按钮" width sortable>
          <el-switch v-model="menuForm.type" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="按钮显示位置" prop="buttonShow" v-if="menuForm.type">
          <el-select v-model="menuForm.buttonShow" placeholder="请选择" clearable>
            <el-option label="页面顶部操作栏" :value="10"></el-option>
            <el-option label="表格右侧操作栏" :value="20"></el-option>
            <el-option label="单纯接口调用" :value="30"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="按钮事件" prop="buttonFunc"
          v-if="menuForm.type && menuForm.buttonShow && menuForm.buttonShow != 30">
          <el-input v-model="menuForm.buttonFunc"></el-input>
        </el-form-item>
        <el-form-item label="按钮类型" prop="buttonType"
          v-if="menuForm.type && menuForm.buttonShow && menuForm.buttonShow != 30">
          <el-select v-model="menuForm.buttonType" placeholder="请选择" clearable>
            <el-option label="默认按钮" value="null"></el-option>
            <el-option label="主要按钮（primary）" value="primary"></el-option>
            <el-option label="成功按钮（success）" value="success"></el-option>
            <el-option label="信息按钮（info）" value="info"></el-option>
            <el-option label="警告按钮（warning）" value="warning"></el-option>
            <el-option label="危险按钮（danger）" value="danger"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="isVisible" label="是否显示">
          <el-switch v-model="menuForm.isVisible"></el-switch>
        </el-form-item>
        <el-form-item prop="isKeepAlive" label="keepAlive">
          <el-switch v-model="menuForm.isKeepAlive"></el-switch>
        </el-form-item>
        <el-form-item prop="pidArr" label="父级菜单">
          <el-cascader style="width: 400px" v-model="menuForm.pidArr" :options="menuTreeList" filterable
            change-on-select></el-cascader>
        </el-form-item>
        <el-form-item label="API接口">
          <el-input v-model="menuForm.api" style="width:80"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="menuFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="submitMenu" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetAllMenu,
  GetMenuTree,
  CreateMenu,
  GetMenuDetail,
  UpdateMenu,
  DeleteMenu
} from "../../api/api";
import toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
export default {
  components: { toolbar },
  data() {
    return {
      buttonList_toolBar: [],

      menuList: [],
      tableLoading: false,
      currentRow: null,
      total: 0,
      pageIndex: 1,
      pageSize: 10,

      menuFormVisible: false,
      isEdit: false,
      menuForm: {
        name: "",
        displayName: "",
        type: 0,
        parentId: null,
        pidArr: null,
        isActive: true,
        isVisible: true,
        order: 0,
        isKeepAlive: false,
        url: "",
        api: "",
        icon: "",
        target: "",
        buttonShow: null,
        buttonType: null,
        buttonFunc: "",
        customExtension: ""
      },
      menuFormRules: {
        name: [
          { required: true, message: '请输入菜单英文名', trigger: 'blur' },
          { message: '请输入菜单英文名', trigger: ['blur', 'change'] }
        ],
        displayName: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' },
          { message: '请输入菜单名称', trigger: ['blur', 'change'] }
        ],
        url: [
          { required: true, message: '请输入路由地址', trigger: 'blur' },
          { message: '请输入路由地址', trigger: ['blur', 'change'] }
        ],
        pidArr: [
          { type: 'array', required: true, message: '请选择父级菜单', trigger: 'change' }
        ],
        buttonShow: [
          { required: true, message: '请选择按钮显示位置', trigger: 'change' }
        ],
        buttonType: [
          { required: true, message: '请选择按钮类型', trigger: 'change' }
        ],
        buttonFunc: [
          { required: true, message: '请输入按钮事件', trigger: 'blur' },
          { message: '请输入按钮事件', trigger: ['blur', 'change'] }
        ],
      },
      menuTreeList: [],
      submitLoading: false
    };
  },
  mounted() {
    this.getMenuList();
    this.getMenuTreeList();
    this.renderButton();
  },
  methods: {
    renderButton() {
      let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
      var buttonList = getButtonList(this.$route.path, routers);
      this.buttonList_toolBar = buttonList.filter((item) => {
        return item.buttonShow == 10 && item.isVisible;
      });
    },
    callFunction(item) {
      this[item.buttonFunc](item);
    },
    getMenuList() {
      let para = { ParentId: 0, SkipCount: 0, MaxResultCount: 50 };
      this.tableLoading = true;
      let that = this;
      GetAllMenu(para).then((res) => {
        that.tableLoading = false;
        that.total = res.data.result.totalCount;
        that.menuList = res.data.result.items;
      });
    },
    // 懒加载菜单
    load(tree, treeNode, resolve) {
      let params = { ParentId: tree.id, SkipCount: 0, MaxResultCount: 50 };
      GetAllMenu(params).then((res) => {
        resolve(res.data.result.items);
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    handleCurrentChange(e) {
      this.pageIndex = e;
      this.getMenuList();
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.getMenuList();
    },
    addMenu() {
      this.menuFormVisible = true;
      this.isEdit = false;
      this.menuForm = {
        name: "",
        displayName: "",
        type: 0,
        parentId: null,
        pidArr: null,
        isActive: true,
        isVisible: true,
        order: 0,
        isKeepAlive: false,
        url: "",
        api: "",
        icon: "",
        target: "",
        buttonShow: null,
        buttonType: null,
        buttonFunc: "",
        customExtension: ""
      };
    },
    getMenuTreeList() {
      GetMenuTree().then((res) => {
        this.menuTreeList = this.loopMenuTree([res.data.result]);
      });
    },
    // 递归封装菜单树
    loopMenuTree(treeList) {
      const newList = treeList.filter(item => {
        if (!item.data.Id) {
          item.value = 0 + '',
            item.label = '根节点'
        } else {
          item.value = item.data.Id + '';
          item.label = item.data.DisplayName;
        }
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    editMenu() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择要编辑的一行数据！');
      }
      let params = { Id: row.id };
      let that = this;
      GetMenuDetail(params).then((res) => {
        if (res.data.success) {
          let customExtension = JSON.parse(res.data.result.customExtension);
          let form = res.data.result;
          // 此处的pidArr是动态添加到表单中的，会导致pidArr字段的校验失败，所以我去掉了级联选择器上的可清空属性
          form.pidArr = customExtension.pidArr;
          form.buttonShow = customExtension.buttonShow;
          form.buttonType = customExtension.buttonType;
          form.buttonFunc = customExtension.buttonFunc;
          that.menuForm = form;
          that.isEdit = true;
          that.menuFormVisible = true;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    delMenu() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择要删除的一行数据！');
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        this.tableLoading = true;
        let params = { Id: row.id };
        DeleteMenu(params).then((res) => {
          this.tableLoading = false;
          if (res.data.success) {
            this.$message.success('删除成功');
            this.getMenuList();
            this.getMenuTreeList()
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }).catch(() => { });
    },
    submitMenu() {
      let that = this;
      that.$refs.menuForm.validate((valid) => {
        if (valid) {
          that.$confirm("确认提交吗？", "提示", {
            closeOnClickModal: false,
          }).then(() => {
            that.submitLoading = true;
            that.menuForm.customExtension = JSON.stringify({
              pidArr: that.menuForm.pidArr,
              buttonShow: that.menuForm.buttonShow,
              buttonType: that.menuForm.buttonType,
              buttonFunc: that.menuForm.buttonFunc
            });
            that.menuForm.parentId = that.menuForm.pidArr[that.menuForm.pidArr.length - 1];
            if (!that.isEdit) {
              CreateMenu(that.menuForm).then((res) => {
                that.submitLoading = false;
                if (res.data.success) {
                  that.$message.success('新增成功');
                  that.menuFormVisible = false;
                  that.getMenuList();
                  this.getMenuTreeList()
                } else {
                  that.$message.error(res.data.msg);
                }
              });
            } else {
              UpdateMenu(that.menuForm).then((res) => {
                that.submitLoading = false;
                if (res.data.success) {
                  that.$message.success('修改成功');
                  that.menuFormVisible = false;
                  this.getMenuList();
                  this.getMenuTreeList()
                } else {
                  that.$message.error(res.data.error.message);
                }
              });
            }
          }).catch(() => { });
        }
      });
    }
  }
};
</script>
<style scoped>
</style>
